export enum SaleType {
    Scheda = 'Scheda',
    PhysicalCoaching = 'Physical Coaching',
}

export enum PaymentStatus {
    Paid = 'Pagato',
    Pending = 'In attesa',
}

export interface Sale {
    id: number;
    type: SaleType;
    customerName: string;
    date: string;
    amount: number;
    paymentStatus: PaymentStatus;
    notes?: string;
}

export const MOCK_SALES: Sale[] = [
    { id: 1, type: SaleType.Scheda, customerName: 'Marco Rossi', date: '2026-02-08', amount: 45.00, paymentStatus: PaymentStatus.Paid, notes: 'Scheda massa 4 settimane' },
    { id: 2, type: SaleType.PhysicalCoaching, customerName: 'Giulia Bianchi', date: '2026-02-07', amount: 120.00, paymentStatus: PaymentStatus.Paid },
    { id: 3, type: SaleType.Scheda, customerName: 'Luca Verdi', date: '2026-02-05', amount: 50.00, paymentStatus: PaymentStatus.Pending, notes: 'Scheda definizione' },
    { id: 4, type: SaleType.PhysicalCoaching, customerName: 'Sara Conti', date: '2026-02-03', amount: 150.00, paymentStatus: PaymentStatus.Paid },
    { id: 5, type: SaleType.Scheda, customerName: 'Andrea Ferrari', date: '2026-01-30', amount: 45.00, paymentStatus: PaymentStatus.Paid },
    { id: 6, type: SaleType.PhysicalCoaching, customerName: 'Elena Marino', date: '2026-01-28', amount: 120.00, paymentStatus: PaymentStatus.Pending, notes: 'Primo mese coaching' },
    { id: 7, type: SaleType.Scheda, customerName: 'Davide Romano', date: '2026-01-25', amount: 55.00, paymentStatus: PaymentStatus.Paid },
    { id: 8, type: SaleType.PhysicalCoaching, customerName: 'Chiara Lombardi', date: '2026-01-20', amount: 150.00, paymentStatus: PaymentStatus.Paid },
    { id: 9, type: SaleType.Scheda, customerName: 'Francesco Ricci', date: '2026-01-18', amount: 40.00, paymentStatus: PaymentStatus.Pending },
    { id: 10, type: SaleType.PhysicalCoaching, customerName: 'Martina Galli', date: '2026-01-15', amount: 130.00, paymentStatus: PaymentStatus.Paid, notes: 'Rinnovo trimestrale' },
];

export function getSalesTotals(sales: Sale[]) {
    const count = sales.length;
    const revenue = sales.reduce((sum, s) => sum + s.amount, 0);
    const paidCount = sales.filter(s => s.paymentStatus === PaymentStatus.Paid).length;
    const pendingCount = sales.filter(s => s.paymentStatus === PaymentStatus.Pending).length;
    const schedaItems = sales.filter(s => s.type === SaleType.Scheda);
    const coachingItems = sales.filter(s => s.type === SaleType.PhysicalCoaching);
    return {
        count,
        revenue,
        paidCount,
        pendingCount,
        schedaCount: schedaItems.length,
        coachingCount: coachingItems.length,
        schedaRevenue: schedaItems.reduce((sum, s) => sum + s.amount, 0),
        coachingRevenue: coachingItems.reduce((sum, s) => sum + s.amount, 0),
    };
}
